import { Route, Routes } from "react-router-dom";
import { HomePage } from "./components/pages/home/index";
import { BlogPage } from "./components/pages/blog/index";
import { ContactPage } from "./components/pages/contact/index";
import { PageRoutes } from "./constants/routes";
import { MainTemplate } from "./components/templates/MainTemplate";
import { AboutPage } from "./components/pages/about/index";
import { ResidentialPage } from "./components/pages/property/residential";
import { CommercialPage } from "./components/pages/property/commercial";
import { BlogDetailPage } from "./components/pages/blog_detail/index";
import { PropertyDetailPage } from "./components/pages/property_detail/index";
import { ScrollToTop } from "./components/atoms/ScrollToTop";

export const RouteConfig = () => {

  return (
    <>
      <ScrollToTop />
      <Routes>
        <Route path={PageRoutes.HOME} element={<MainTemplate />}>
          <Route index element={<HomePage />} />
        </Route>
        <Route path={PageRoutes.PROPERTY.RESIDENTIAL} element={<MainTemplate />}>
          <Route index element={<ResidentialPage />} />
        </Route>
        <Route path={PageRoutes.PROPERTY.COMMERCIAL} element={<MainTemplate />}>
          <Route index element={<CommercialPage />} />
        </Route>
        <Route path={PageRoutes.BLOG} element={<MainTemplate />}>
          <Route index element={<BlogPage />} />
        </Route>
        <Route path={PageRoutes.BLOG_DETAIL} element={<MainTemplate />}>
          <Route index element={<BlogDetailPage />} />
        </Route>
        <Route path={PageRoutes.ABOUT} element={<MainTemplate />}>
          <Route index element={<AboutPage />} />
        </Route>
        <Route path={PageRoutes.CONTACT} element={<MainTemplate />}>
          <Route index element={<ContactPage />} />
        </Route>
        <Route path={PageRoutes.PROPERTY_DETAIL} element={<MainTemplate />}>
          <Route index element={<PropertyDetailPage />} />
        </Route>
      </Routes>
    </>
  );
};
